export default "__VITE_ASSET__DsDiuI1F__"